import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import AcceptedView from './Accepted.view';

export class AcceptedContainer extends Component {

  constructor(props){
    super(props);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    const { code } = this.props.location.query;
    dispatch({
      type: 'TOKEN_RECEIVED',
      payload: {
        code,
      },
    });
  }

  render() {
    return (<AcceptedView
      {...this.props}
    />);
  }

}

function mapStateToProps(state) {
  const { accepted } = state;
  return {
    status: accepted.status,
    message: accepted.message,
  };
}

export default connect(mapStateToProps)(withRouter(AcceptedContainer));



// WEBPACK FOOTER //
// ./src/app/modules/Ebay/OAuth/Accepted/Accepted.container.js